import { render, staticRenderFns } from "./testnum.vue?vue&type=template&id=b4f9d8be&"
import script from "./testnum.vue?vue&type=script&lang=js&"
export * from "./testnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports